import React from 'react';
import * as Icons from 'lucide-react';
import { features } from '../mock';

export default function Features() {
  return (
    <section className="py-16 lg:py-24 bg-[#FFF8EC]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-7">
            <span className="text-[#4FB3B8] uppercase tracking-[0.25em] font-black text-xs">Why parents pick us</span>
            <h2 className="mt-3 text-3xl lg:text-5xl font-black text-[#2C3E50] leading-[1.05]">
              Small things done right, <br className="hidden sm:block"/> <span className="text-[#E64B2B]">every single day.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-lg text-[#2C3E50]/80">
            No flashy promises. Just consistent, high-quality tuition with tutors who genuinely enjoy teaching.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f) => {
            const Ic = Icons[f.icon] || Icons.Star;
            return (
              <div key={f.title} className="group bg-white rounded-2xl border-2 border-[#2C3E50] p-6 hover:-translate-y-1 hover:paper-shadow-sm">
                <div className="w-12 h-12 rounded-xl bg-[#F4B93E] border-2 border-[#2C3E50] flex items-center justify-center mb-4 group-hover:bg-[#4FB3B8]">
                  <Ic size={22} className="text-[#2C3E50]" strokeWidth={2.4} />
                </div>
                <h3 className="text-xl font-black text-[#2C3E50]">{f.title}</h3>
                <p className="mt-2 text-[#2C3E50]/75 font-medium leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
